"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePartnerParam = exports.PartnerUrlQueryParams = void 0;
const oneaudi_os_utils_1 = require("@volkswagen-onehub/oneaudi-os-utils");
const useIsStandaloneMode_1 = require("./useIsStandaloneMode");
var PartnerUrlQueryParams;
(function (PartnerUrlQueryParams) {
    PartnerUrlQueryParams["PARTNER_ID"] = "partnerId";
    PartnerUrlQueryParams["LOCALE"] = "locale";
})(PartnerUrlQueryParams || (exports.PartnerUrlQueryParams = PartnerUrlQueryParams = {}));
/**
 * Returns requested GET Param if given and only if feature app is running in standalone mode
 */
function usePartnerParam(param) {
    const isStandalone = (0, useIsStandaloneMode_1.useIsStandaloneMode)();
    if (isStandalone) {
        return (0, oneaudi_os_utils_1.getParam)(param);
    }
    return null;
}
exports.usePartnerParam = usePartnerParam;
//# sourceMappingURL=usePartnerParam.js.map